import { render, staticRenderFns } from "./big-banner.vue?vue&type=template&id=252def00&scoped=true&lang=pug&"
import script from "./big-banner.vue?vue&type=script&lang=js&"
export * from "./big-banner.vue?vue&type=script&lang=js&"
import style0 from "./big-banner.vue?vue&type=style&index=0&id=252def00&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252def00",
  null
  
)

export default component.exports